import reducerRegistry from 'reduxUtils/reducerRegistry';
import makeRequest from 'utils/makeRequest';
import {
  getSiteDomain,
  createSlug,
  addTimeParameterInUrl,
  getMsidFromPath,
} from 'utils/common';
import _get from 'lodash.get';
import produce from 'immer';
import { getFeedUrl, getInternalFeedUrl } from 'helpers/feeds/generalHelpers';
import { TOI_LIVE_DOMAIN } from '../../constants';
import { arrayToHashMap } from '../../components/ElectionV2/utils/loksabhaComputation';

const reducerName = 'newslisting';
const createActionName = name => `toi/${reducerName}/${name}`;

const HP_CONTENT_FEED_PATH = '/toi/web/page/content?path=/';
const WEB_NEWS_LISTING_CONTENT_FEED_PATH = '/toi/web/list/news?path=';
const WEB_NEWS_V2_LISTING_CONTENT_FEED_PATH = '/toi/web/list/etimesnews?path=';
const WAP_NEWS_LISTING_CONTENT_FEED_PATH = '/toi/web/list/news?path=';
const WEB_NEWS_DETAILS_CONTENT_FEED_PATH = '/toi/web/show/news?path=';
const ELECTIONS_NEWS_LISTING_CONTENT_FEED_PATH =
  '/toi/web/list/electionnews?path=';
const WAP_PHOTO_LISTING_CONTENT_FEED_PATH =
  '/toi/web/list/microservice?version=v2&path=';
const WEB_PHOTO_LISTING_CONTENT_FEED_PATH =
  '/toi/web/list/microservice?version=v2&path=';
export const RECEIVE_NEWS_LISTING_PAGE_DATA = createActionName(
  'RECEIVE_NEWS_LISTING_PAGE_DATA',
);
export const RECEIVE_HALLOFFAME_DETAILS_PAGE_DATA = createActionName(
  'RECEIVE_HALLOFFAME_DETAILS_PAGE_DATA',
);
export const RECEIVE_BUDGET_O_METER_DATA = createActionName(
  'RECEIVE_BUDGET_O_METER_DATA',
);
export const RECEIVE_YEAR_WISE_CONST_DATA = createActionName(
  'RECEIVE_YEAR_WISE_CONST_DATA',
);
export const RECEIVE_YEAR_WISE_PARTY_DATA = createActionName(
  'RECEIVE_YEAR_WISE_PARTY_DATA',
);
export const RECEIVE_YEAR_WISE_CANDIDATE_DATA = createActionName(
  'RECEIVE_YEAR_WISE_CANDIDATE_DATA',
);
export const RECEIVE_YEAR_WISE_SCHEDULE_DATA = createActionName(
  'RECEIVE_YEAR_WISE_SCHEDULE_DATA',
);
export const RECEIVE_FILTER_DATA = createActionName('RECEIVE_FILTER_DATA');
export const RECEIVE_STATE_CONST_NAMES_MAPPING = createActionName(
  'RECEIVE_STATE_CONST_NAMES_MAPPING',
);
export const RECEIVE_LATEST_YEAR_TOP_CANDIDATE_DATA_REFRESH = createActionName(
  'RECEIVE_LATEST_YEAR_TOP_CANDIDATE_DATA_REFRESH',
);
export const RECEIVE_LATEST_YEAR_TOP_CANDIDATE_DATA = createActionName(
  'RECEIVE_LATEST_YEAR_TOP_CANDIDATE_DATA',
);
export const RECEIVE_PHOTO_LISTING_PAGE_DATA = createActionName(
  'RECEIVE_PHOTO_LISTING_PAGE_DATA',
);
export const HANDLE_NEWS_LISTING_PAGE_DATA_ERROR = createActionName(
  'HANDLE_NEWS_LISTING_PAGE_DATA_ERROR',
);

export const HANDLE_PHOTO_LISTING_PAGE_DATA_ERROR = createActionName(
  'HANDLE_PHOTO_LISTING_PAGE_DATA_ERROR',
);

export const RECEIVE_WU_DATA = createActionName('RECEIVE_WU_DATA');

export const HANDLE_SEO_DATA_ERROR = createActionName('HANDLE_SEO_DATA_ERROR');

export const DATA_LOADING = createActionName('DATA_LOADING');
export const DATA_LOADED = createActionName('DATA_LOADED');
export const RECEIVE_CARDS_INSERT_DATA = createActionName(
  'RECEIVE_CARDS_INSERT_DATA',
);
export const HANDLE_CARDS_INSERTS_DATA_ERROR = createActionName(
  'HANDLE_CARDS_INSERTS_DATA_ERROR',
);

export const RECEIVE_AJAX_SECTION_DATA = createActionName(
  'RECEIVE_AJAX_SECTION_DATA',
);

export const RECEIVE_SEO_DATA = createActionName('RECEIVE_SEO_DATA');
function fetchSingleHallOfFameData(params) {
  const primeParam = params.isPrime ? '&pc1=yes' : '';
  // // const subSections = params.subSection ? params.subSection.subsections : '';
  const feedPath = params.isWapView
    ? WEB_NEWS_DETAILS_CONTENT_FEED_PATH
    : WEB_NEWS_DETAILS_CONTENT_FEED_PATH;
  const feedPath1 = params.isWapView
    ? WAP_NEWS_LISTING_CONTENT_FEED_PATH
    : WEB_NEWS_LISTING_CONTENT_FEED_PATH;
  const articlePath = `/articleshow/${getMsidFromPath(params.fullPath)}.cms`;
  const url = `${getFeedUrl()}${feedPath}${articlePath}${primeParam}`;
  const listurl = `${getFeedUrl()}${feedPath1}${`/sports/paris-olympics-2024/hall-of-fame-detail`}${primeParam}`;
  return [
    makeRequest.get(listurl, { isMobile: params.isWapView }, 'skipfeedengine'),
    makeRequest.get(url, { isMobile: params.isWapView }, 'skipfeedengine'),
  ];
}

function fetchSingleSportData(params) {
  const primeParam = params.isPrime ? '&pc1=yes' : '';
  // // const subSections = params.subSection ? params.subSection.subsections : '';
  const feedPath = params.isWapView
    ? WEB_NEWS_DETAILS_CONTENT_FEED_PATH
    : WEB_NEWS_DETAILS_CONTENT_FEED_PATH;
  const feedPath1 = params.isWapView
    ? WAP_NEWS_LISTING_CONTENT_FEED_PATH
    : WEB_NEWS_LISTING_CONTENT_FEED_PATH;
  const articlePath = `/articleshow/${getMsidFromPath(params.fullPath)}.cms`;
  const url = `${getFeedUrl()}${feedPath}${articlePath}${primeParam}`;
  const listurl = `${getFeedUrl()}${feedPath1}${`/sports/paris-olympics-2024/olympics-sports-detail`}${primeParam}`;
  return [
    makeRequest.get(listurl, { isMobile: params.isWapView }, 'skipfeedengine'),
    makeRequest.get(url, { isMobile: params.isWapView }, 'skipfeedengine'),
  ];
}

function fetchNewsListingData(params) {
  const primeParam = params.isPrime ? '&pc1=yes' : '';
  // const subSections = params.subSection ? params.subSection.subsections : '';
  let feedPath = params.isWapView
    ? WAP_NEWS_LISTING_CONTENT_FEED_PATH
    : WEB_NEWS_LISTING_CONTENT_FEED_PATH;
  if (params.isNewsListingV2Page) {
    feedPath = params.isWapView
      ? WEB_NEWS_V2_LISTING_CONTENT_FEED_PATH
      : WEB_NEWS_V2_LISTING_CONTENT_FEED_PATH;
  }

  let url = `${getFeedUrl()}${feedPath}${params.fullPath}${primeParam}`;
  if (params.useInternalFeed) {
    url = `${getInternalFeedUrl()}${feedPath}${params.fullPath}${primeParam}`;
  }
  return makeRequest.get(url, { isMobile: params.isWapView }, 'skipfeedengine');
}

function fetchSeoData(params) {
  const url = `${getSiteDomain()}/feed_jarvis_seodata.cms?msid=${
    params.boardResultMsid
  }&feedtype=sjson`;
  return makeRequest.get(url, {}, 'skipfeedengine');
}

function fetchBoardResultPageData(params) {
  const url = `https://psn.timesofindia.com/events-manager/result/page/init?msid=${
    params.boardResultMsid
  }`;

  const seoUrl = `${getSiteDomain()}/feed_jarvis_seodata.cms?msid=${
    params.boardResultMsid
  }&feedtype=sjson`;

  return [
    makeRequest.get(url, { isMobile: params.isWapView }, 'skipfeedengine'),
    makeRequest.get(seoUrl, {}, 'skipfeedengine'),
  ];
}

function fetchElectionNewsListingData(params) {
  const primeParam = params.isPrime ? '&pc1=yes' : '';
  // const subSections = params.subSection ? params.subSection.subsections : '';
  let feedPath = params.isWapView
    ? WAP_NEWS_LISTING_CONTENT_FEED_PATH
    : WEB_NEWS_LISTING_CONTENT_FEED_PATH;
  feedPath = !params.isConstituencyPage
    ? feedPath
    : ELECTIONS_NEWS_LISTING_CONTENT_FEED_PATH;
  const url = `${getFeedUrl()}${feedPath}${params.fullPath}${primeParam}`;

  return makeRequest.get(url, { isMobile: params.isWapView }, 'skipfeedengine');
}

function fetchBudgetoMeterData() {
  const requestParams = {
    params: {},
  };
  const feedPath = '/feed_budgetometer';
  const url = `${getSiteDomain()}${feedPath}.cms?feedtype=sjson`;
  return makeRequest.get(url, requestParams, 'skipfeedengine');
}

function fetchDataFromUrl(url) {
  return makeRequest.get(url, 'skipfeedengine');
}

function fetchPhotoListingData(params) {
  const primeParam = params.isPrime ? '&pc1=yes' : '';
  // const subSections = params.subSection ? params.subSection.subsections : '';
  // if (
  //   params &&
  //   params.fullPath &&
  //   params.fullPath.indexOf('/city/photos') > -1
  // ) {
  const feedPath = params.isWapView
    ? WAP_PHOTO_LISTING_CONTENT_FEED_PATH
    : WEB_PHOTO_LISTING_CONTENT_FEED_PATH;
  // } else {
  //   feedPath = params.isWapView
  //     ? WAP_NEWS_LISTING_CONTENT_FEED_PATH
  //     : WEB_NEWS_LISTING_CONTENT_FEED_PATH;
  // }
  const url = `${getFeedUrl()}${feedPath}${params.fullPath}${primeParam}`;
  return makeRequest.get(url, { isMobile: params.isWapView }, 'skipfeedengine');
}

export function dataLoading() {
  return {
    type: DATA_LOADING,
    payload: {},
  };
}

export function dataLoaded() {
  return {
    type: DATA_LOADED,
    payload: {},
  };
}

function handleNewsListingPageDataError() {
  return {
    type: HANDLE_NEWS_LISTING_PAGE_DATA_ERROR,
    payload: {},
  };
}

function handlePhotoListingPageDataError() {
  return {
    type: HANDLE_PHOTO_LISTING_PAGE_DATA_ERROR,
    payload: {},
  };
}

function receiveCardsInsertData(data) {
  return {
    type: RECEIVE_CARDS_INSERT_DATA,
    payload: data,
  };
}

function handleCardsInsertDataError() {
  return {
    type: HANDLE_CARDS_INSERTS_DATA_ERROR,
    payload: {},
  };
}

function handleSeoDataError() {
  return {
    type: HANDLE_SEO_DATA_ERROR,
    payload: {},
  };
}

export function reciveNewsListingData(data) {
  return {
    type: RECEIVE_NEWS_LISTING_PAGE_DATA,
    payload: data,
  };
}

export function reciveHallOfFameDetailsData(data) {
  return {
    type: RECEIVE_HALLOFFAME_DETAILS_PAGE_DATA,
    payload: data,
  };
}

export function reciveBudgetoMeterData(data) {
  return {
    type: RECEIVE_BUDGET_O_METER_DATA,
    payload: data,
  };
}

export function recivePhotoListingData(data) {
  return {
    type: RECEIVE_PHOTO_LISTING_PAGE_DATA,
    payload: data,
  };
}

export function reciveLatestyearTopCandidateData(data) {
  return {
    type: RECEIVE_LATEST_YEAR_TOP_CANDIDATE_DATA,
    payload: data,
  };
}

export function reciveLatestyearTopCandidateDataRefresh(data) {
  return {
    type: RECEIVE_LATEST_YEAR_TOP_CANDIDATE_DATA_REFRESH,
    payload: data,
  };
}

export function reciveStateConstNamesMapping(data) {
  return {
    type: RECEIVE_STATE_CONST_NAMES_MAPPING,
    payload: data,
  };
}

export function recieveYearWiseConstituencyData(data) {
  return {
    type: RECEIVE_YEAR_WISE_CONST_DATA,
    payload: data,
  };
}

export function recieveYearWisePartyData(data) {
  return {
    type: RECEIVE_YEAR_WISE_PARTY_DATA,
    payload: data,
  };
}

export function recieveYearWiseCandidatesData(data) {
  return {
    type: RECEIVE_YEAR_WISE_CANDIDATE_DATA,
    payload: data,
  };
}

export function recieveYearWiseScheduleData(data) {
  return {
    type: RECEIVE_YEAR_WISE_SCHEDULE_DATA,
    payload: data,
  };
}

export function recieveWUData(data) {
  return {
    type: RECEIVE_WU_DATA,
    payload: data,
  };
}

export function recieveFilterData(data) {
  return {
    type: RECEIVE_FILTER_DATA,
    payload: data,
  };
}

function receiveSeoData(data) {
  return {
    type: RECEIVE_SEO_DATA,
    payload: data,
  };
}

export function loadNewsListingPageData(params) {
  if (params && params.boardResultMsid && params.boardResultMsid !== '') {
    return dispatch =>
      Promise.all(fetchBoardResultPageData(params))
        .then(data => {
          let finalData = Array.isArray(data) && data[0] && data[0].data;
          if (finalData && data[1] && data[1].data) {
            finalData = { ...finalData, ...data[1].data };
          }
          dispatch(reciveNewsListingData(finalData, params));
        })
        .catch(error => {
          dispatch(handleNewsListingPageDataError(error));
        });
  }
  return dispatch =>
    fetchNewsListingData(params)
      .then(response => {
        dispatch(reciveNewsListingData(response.data, params));
      })
      .catch(error => {
        dispatch(handleNewsListingPageDataError(error));
      });
}

export function loadHallOfFameDetailPageData(params) {
  return dispatch =>
    Promise.all(fetchSingleHallOfFameData(params))
      .then(data => {
        let finalData = Array.isArray(data) && data[0] && data[0].data;
        if (finalData && data[1] && data[1].data) {
          finalData = { ...finalData, ...data[1].data };
        }
        dispatch(reciveNewsListingData(finalData, params));
      })
      .catch(error => {
        dispatch(handleNewsListingPageDataError(error));
      });
}

export function loadOlympicsSportsDetailPageData(params) {
  return dispatch =>
    Promise.all(fetchSingleSportData(params))
      .then(data => {
        let finalData = Array.isArray(data) && data[0] && data[0].data;
        if (finalData && data[1] && data[1].data) {
          finalData = { ...finalData, ...data[1].data };
        }
        dispatch(reciveNewsListingData(finalData, params));
      })
      .catch(error => {
        dispatch(handleNewsListingPageDataError(error));
      });
}
export function loadSeoData(params) {
  return dispatch =>
    fetchSeoData(params)
      .then(response => {
        dispatch(receiveSeoData(response.data, params));
      })
      .catch(error => {
        dispatch(handleSeoDataError(error));
      });
}

export function loadPhotoListingData(params) {
  return dispatch =>
    fetchPhotoListingData(params)
      .then(response => {
        dispatch(recivePhotoListingData(response.data, params));
      })
      .catch(error => {
        dispatch(handlePhotoListingPageDataError(error));
      });
}

function fetchCardsInsert(url) {
  return makeRequest.get(url, 'skipfeedengine');
}
export function loadCardsInsert(url) {
  return dispatch =>
    fetchCardsInsert(url)
      .then(response => {
        dispatch(receiveCardsInsertData(response.data));
      })
      .catch(error => {
        dispatch(handleCardsInsertDataError(error));
      });
}

function fetchSectionAjaxData({ clickedItem, sectionId, isPrime }, isMobile) {
  const { subsectiondID, dataUrl } = clickedItem;
  const primeParam = isPrime ? '&pc=yes' : '';
  const url =
    dataUrl ||
    `${getFeedUrl()}${HP_CONTENT_FEED_PATH}&sectionid=${sectionId}&subsectionid=${subsectiondID}${primeParam}`;
  return makeRequest.get(url, { isMobile });
}

function receiveSectionAjaxData(data, params) {
  return {
    type: RECEIVE_AJAX_SECTION_DATA,
    payload: {
      ajaxData: data,
      params,
    },
  };
}

export function loadAjaxSectionData(params) {
  let sectionId = '';
  if (typeof params.sectionId === 'string') {
    sectionId = params.sectionId.toLowerCase();
  }
  return (dispatch, getState) => {
    const appState = getState();
    const { isMobile } = appState;
    if (sectionId === 'videos') {
      // dispatch(toggleVideosSectionLoader(true));
    }
    return fetchSectionAjaxData(params, isMobile)
      .then(response => {
        dispatch(receiveSectionAjaxData(response.data, params));
        if (sectionId === 'videos') {
          // dispatch(toggleVideosSectionLoader(false));
        }
      })
      .catch(() => {
        // dispatch(handleHomePageDataError(error));
        if (sectionId === 'videos') {
          // dispatch(toggleVideosSectionLoader(false));
        }
      });
  };
}

function getTopCandidates(constituency, number = 2, percentage = false) {
  if (constituency && Array.isArray(constituency) && constituency.length > 1) {
    let candidates = constituency;
    const name = candidates[0]?.cns_name;
    let vm = 0;
    let totalTc = 0;
    const percentages = [];
    if (percentage) {
      candidates.forEach(item => {
        totalTc += item.tc;
      });

      if (totalTc) {
        candidates = constituency.sort((a, b) => b.tc - a.tc);
        vm = Math.abs(candidates[0].tc - candidates[1].tc);
        candidates.forEach(item => {
          const percentag = item.tc / totalTc * 100;
          percentages.push({ ...item, pr: `${percentag.toFixed(2)}` });
        });
      } else {
        candidates = constituency.sort((a, b) => a.cs - b.cs);
        candidates.forEach(item => {
          percentages.push({ ...item });
        });
      }
    }
    const { sn, ey } = candidates[0];
    return {
      top_candidates: percentage
        ? percentages.slice(0, number)
        : candidates.slice(0, number),
      name,
      vm,
      slug: createSlug(name),
      link: `${TOI_LIVE_DOMAIN}/elections/assembly-elections/${createSlug(
        sn,
      )}/constituency-show/${createSlug(name)}`,
      year: ey || 2023,
    };
  }
  return null;
}

function getVsCandidatesInConstituency(cnt_rslt, cns_name) {
  if (cnt_rslt && cns_name) {
    const cnsNameMap = {};
    cnt_rslt.forEach(candidate => {
      const cnsName = candidate.cns_name;
      const slugCnsName = createSlug(cnsName);
      if (slugCnsName === createSlug(cns_name) && cnsNameMap[slugCnsName]) {
        cnsNameMap[slugCnsName] = [...cnsNameMap[slugCnsName], candidate];
      } else if (slugCnsName === createSlug(cns_name)) {
        cnsNameMap[slugCnsName] = [candidate];
      }
    });
    return getTopCandidates(cnsNameMap[createSlug(cns_name)], 20, true);
  }
  return null;
}

function getPresentAndImcumbentCandidatesInState(data) {
  const loksabha = data?.yearData?.loksabha;
  if (data?.yearData?.loksabha) {
    const newData = {};
    newData.loksabha = {};
    newData.loksabha.cns_rslt = data.constData.yrdata[0].states.map(
      state => state.cns,
    );
    newData.loksabha.cns_rslt = newData.loksabha.cns_rslt.flat();
    data.constData = { ...newData };
  }
  data = { ...data.constData };
  if (
    data &&
    Object.values(data) &&
    Array.isArray(Object.values(data)) &&
    Object.values(data).length
  ) {
    const stateNameSlug = Object.keys(data)[0];
    data = Object.values(data)[0]?.cns_rslt;
    const data1 = data.map(constituency => ({
      ...constituency,
      link: loksabha
        ? `${TOI_LIVE_DOMAIN}/elections/lok-sabha-constituencies/${createSlug(
            constituency?.sn || stateNameSlug,
          )}/${createSlug(constituency?.cns_name)}`
        : `${TOI_LIVE_DOMAIN}/elections/assembly-elections/${createSlug(
            constituency?.sn || stateNameSlug,
          )}/constituency-show/${createSlug(constituency?.cns_name)}`,
      name: constituency?.cns_name,
      slug: createSlug(constituency?.cns_name),
      year: constituency?.ey,
    }));
    return data1;
  }
  return null;
}

export function loadLatestYearTopCandidateData(url, constituency, number = 5) {
  return dispatch =>
    fetchDataFromUrl(addTimeParameterInUrl(url))
      .then(response => {
        dispatch(
          reciveLatestyearTopCandidateDataRefresh({
            ...response.data,
            number,
            constituency,
          }),
        );
      })
      .catch(error => {
        dispatch(handleNewsListingPageDataError(error));
      });
}

export function loadStateConstNamesMapping(url, searchState) {
  return dispatch =>
    fetchDataFromUrl(url)
      .then(response => {
        dispatch(
          reciveStateConstNamesMapping({
            data: response.data,
            searchState,
          }),
        );
      })
      .catch(error => {
        dispatch(handleNewsListingPageDataError(error));
      });
}

export function loadElectionsListingPageData(params) {
  return dispatch =>
    fetchElectionNewsListingData(params)
      .then(response => {
        dispatch(reciveNewsListingData(response.data, params));
        if (!params.isStatePage) {
          dispatch(
            reciveLatestyearTopCandidateData(
              response.data.sectionitems,
              params,
            ),
          );
        }
      })
      .catch(error => {
        dispatch(handleNewsListingPageDataError(error));
      });
}

export function loadBudgetoMeterData(params) {
  return dispatch =>
    fetchBudgetoMeterData(params)
      .then(response => {
        dispatch(reciveBudgetoMeterData(response.data, params));
      })
      .catch(error => {
        dispatch(handleNewsListingPageDataError(error));
      });
}

export function loadYearWiseConstituencyData(
  year,
  searches = [],
  sort = { alpha: 1, key: 'cns_name' },
  loader,
  force = false,
) {
  return dispatch => {
    if (loader) dispatch(dataLoading());
    return fetchDataFromUrl(addTimeParameterInUrl(year?.url))
      .then(response => {
        if (loader) dispatch(dataLoaded());
        dispatch(
          recieveYearWiseConstituencyData({
            constData: response.data,
            searches,
            sort,
            yearData: year,
            force,
          }),
        );
      })
      .catch(error => {
        if (loader) dispatch(dataLoaded());
        dispatch(handleNewsListingPageDataError(error));
      });
  };
}

export function loadYearWisePartyData(year, searches = [], sort = {}, loader) {
  return dispatch => {
    if (loader) dispatch(dataLoading());
    return fetchDataFromUrl(addTimeParameterInUrl(year?.partyUrl))
      .then(response => {
        if (loader) dispatch(dataLoaded());
        dispatch(
          recieveYearWisePartyData({
            partyData: response.data,
            searches,
            sort,
            yearData: year,
          }),
        );
      })
      .catch(error => {
        if (loader) dispatch(dataLoaded());
        dispatch(handleNewsListingPageDataError(error));
      });
  };
}

export function loadYearWiseCandidatesData(
  url,
  year,
  searches = [],
  sort = { alpha: 1, key: 'seonm' },
  loader,
  force = false,
  starCandidatePage = false,
) {
  return dispatch => {
    if (loader) dispatch(dataLoading());
    return fetchDataFromUrl(addTimeParameterInUrl(url))
      .then(response => {
        if (loader) dispatch(dataLoaded());
        dispatch(
          recieveYearWiseCandidatesData({
            candidateData: response.data,
            searches,
            sort,
            yearData: year,
            force,
            starCandidatePage,
          }),
        );
      })
      .catch(error => {
        if (loader) dispatch(dataLoaded());
        dispatch(handleNewsListingPageDataError(error));
      });
  };
}

export function loadYearWiseScheduleData(
  year,
  searches = [],
  sort = { alpha: 1, key: 'sn' },
  loader,
) {
  return dispatch => {
    if (loader) dispatch(dataLoading());
    return fetchDataFromUrl(year?.scheduleUrl)
      .then(response => {
        if (loader) dispatch(dataLoaded());
        dispatch(
          recieveYearWiseScheduleData({
            scheduleData: response.data,
            searches,
            sort,
            yearData: year,
          }),
        );
      })
      .catch(error => {
        if (loader) dispatch(dataLoaded());
        dispatch(handleNewsListingPageDataError(error));
      });
  };
}

export function filterSearchSortData(
  searches = [],
  sort = { alpha: 1, key: '' },
  loader = false,
  schedule = false,
) {
  return dispatch => {
    if (loader) dispatch(dataLoading());
    dispatch(recieveFilterData({ searches, sort, loader, schedule }));
    if (loader) dispatch(dataLoaded());
  };
}

function getSortedAndSearchData({
  data,
  searches = [],
  sort = { alpha: 1, key: '' },
  schedule = false,
}) {
  if (schedule && data?.constituencies) {
    data = data.constituencies;
  }

  if (!(data && Array.isArray(data))) {
    return null;
  }
  searches = searches
    ? Object.entries(searches).map(([key, value]) => ({ key, value }))
    : [];

  if (searches && Array.isArray(searches) && searches.length) {
    // eslint-disable-next-line no-restricted-syntax
    for (const search of searches) {
      if (search.value) {
        // eslint-disable-next-line no-loop-func
        data = data.filter(item => {
          if (
            search.key &&
            typeof search.key === 'string' &&
            search.key.includes('#')
          ) {
            const orConditions = search.key.split('#');
            return orConditions.some(
              condition =>
                item[condition] &&
                createSlug(item[condition]).includes(createSlug(search.value)),
            );
          }
          if (!isNaN(item[search.key])) {
            return item[search.key] === search.value;
          }
          return (
            item[search.key] &&
            createSlug(item[search.key]).includes(createSlug(search.value))
          );
        });
      }
    }
  }

  if (sort?.alpha) {
    data = data.sort((a, b) => {
      const aValue = a[sort.key] || '';
      const bValue = b[sort.key] || '';
      const comparison = String(aValue).localeCompare(String(bValue));
      return sort.alpha > 0 ? comparison : -comparison;
    });
  }
  // if (sort?.margin) {
  //   data = data.sort((a, b) => (sort.margin > 0 ? b.vm - a.vm : a.vm - b.vm));
  // }
  if (schedule) {
    const groupedByPhaseAndSn = data.reduce((acc, curr) => {
      const { phase, sn } = curr;
      if (phase) {
        curr.name = `Phase ${phase}`;
        if (!acc[sn]) {
          acc[sn] = {};
        }
        if (!acc[sn][phase]) {
          acc[sn][phase] = [];
        }
        acc[sn][phase].push(curr);
        return acc;
      }
      return acc;
    }, {});
    data = groupedByPhaseAndSn;
  }
  return data;
}

function constituencyPhaseData(data) {
  let flatData = [];
  data.yrdata[0].states.forEach(state => {
    flatData.push(state.cns);
  });
  flatData = flatData.flat();
  const filteredData = [];
  flatData.forEach(f => {
    if (f?.regInfo?.all) {
      filteredData.push({
        ...f.regInfo.all,
        cns_name: f.cns_name,
        cns_name_seo: createSlug(f.cns_name),
        sn: f.sn,
        sn_seo: createSlug(f.sn),
        ecid: f.ecid,
        cns_id: f.cns_id,
      });
    }
  });

  const groupedByPhase = filteredData.reduce((acc, curr) => {
    const { phase } = curr;
    if (phase) {
      curr.name = `Phase ${phase}`;
      if (!acc[phase]) {
        acc[phase] = [];
      }
      if (acc[phase].length < 1) {
        acc[phase].push(curr);
      }
      return acc;
    }
    return acc;
  }, {});

  return {
    constituencies: filteredData,
    phases: Object.values(groupedByPhase).flat(),
  };
}

export function loadWUData(url, key, loader = false) {
  return dispatch => {
    if (loader) dispatch(dataLoading());
    return fetchDataFromUrl(url)
      .then(response => {
        if (loader) dispatch(dataLoaded());
        dispatch(
          recieveWUData({
            data: response.data,
            key,
          }),
        );
      })
      .catch(error => {
        if (loader) dispatch(dataLoaded());
        dispatch(handleNewsListingPageDataError(error));
      });
  };
}

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case DATA_LOADING: {
      return {
        ...state,
        dataLoading: true,
      };
    }
    case DATA_LOADED: {
      return {
        ...state,
        dataLoading: false,
      };
    }
    case RECEIVE_NEWS_LISTING_PAGE_DATA: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case RECEIVE_SEO_DATA: {
      return {
        ...state,
      };
    }
    case RECEIVE_BUDGET_O_METER_DATA: {
      return {
        ...state,
        budgetoMeter: action.payload,
      };
    }
    case RECEIVE_STATE_CONST_NAMES_MAPPING: {
      const searchState = action.payload?.searchState;
      const stateConstreducer = (accumulator, currentValue) => {
        const { stateName, constituency } = currentValue;
        if (stateName) {
          accumulator[stateName] = accumulator[stateName] || [];
          accumulator[stateName].push({
            name: constituency,
            seoname: createSlug(constituency),
          });
        }

        return accumulator;
      };

      const data =
        action.payload.data &&
        Array.isArray(action.payload.data) &&
        action.payload.data.length &&
        action.payload.data.reduce(stateConstreducer, {});

      let loksabhaStates =
        data &&
        Array.isArray(Object.keys(data)) &&
        Object.keys(data).length > 0 &&
        Object.keys(data)
          .map(d => ({
            name: d,
            seoname: createSlug(d),
          }))
          .sort((a, b) => a.seoname.localeCompare(b.seoname));

      if (searchState) {
        loksabhaStates = loksabhaStates.filter(
          loksabhaState => loksabhaState.seoname === searchState,
        );
      }

      return {
        ...state,
        stateConstMapping: data,
        loksabhaStates: searchState
          ? [...loksabhaStates]
          : [{ name: 'Select State', seoname: '' }, ...loksabhaStates],
      };
    }
    case RECEIVE_YEAR_WISE_CONST_DATA: {
      let fullData = getPresentAndImcumbentCandidatesInState({
        ...action.payload,
      });
      if (
        action?.payload?.yearData?.loksabha &&
        action?.payload?.force &&
        action?.payload?.searches?.sn
      ) {
        fullData = getSortedAndSearchData({
          data: fullData,
          searches: { sn: action.payload.searches.sn },
          sort: action.payload.sort,
        });
      }
      const loksabhaStates =
        action.payload?.yearData?.loksabha &&
        action.payload?.constData?.yrdata &&
        Array.isArray(action.payload.constData.yrdata) &&
        action.payload.constData.yrdata.length &&
        action.payload.constData.yrdata[0].states
          .map(s => ({
            name: s.nm,
            seoname: createSlug(s.nm),
          }))
          .sort((a, b) => a.seoname.localeCompare(b.seoname));
      let stateToReturn = {
        ...state,
        fullData,
        filteredData: getSortedAndSearchData({
          data: fullData,
          searches: action.payload.searches,
          sort: action.payload.sort,
        }),
      };
      if (action.payload?.yearData?.loksabha) {
        stateToReturn = {
          ...stateToReturn,
          loksabha: action.payload?.yearData?.loksabha,
          force: action.payload?.force,
          loksabhaStates:
            action.payload.force && action.payload?.searches?.sn
              ? loksabhaStates.filter(
                  lstate => lstate.seoname === action.payload.searches.sn,
                )
              : [{ name: 'All India', seoname: '' }, ...loksabhaStates],
        };
      }
      return stateToReturn;
    }
    case RECEIVE_YEAR_WISE_PARTY_DATA: {
      if (
        action.payload?.yearData?.loksabha &&
        action.payload?.partyData?.yrdata &&
        Array.isArray(action.payload.partyData.yrdata) &&
        action.payload.partyData.yrdata.length > 0 &&
        action.payload.partyData.yrdata[0].ttl_seats &&
        action.payload.partyData.yrdata[0].pr_rslt &&
        action.payload.partyData.pr_master
      ) {
        let fullData = action.payload.partyData.yrdata[0].pr_rslt;
        const prMasterMap = arrayToHashMap(action.payload.partyData.pr_master);
        fullData = fullData.map(data => ({ ...data, ...prMasterMap[data.nm] }));
        const filteredData = getSortedAndSearchData({
          data: fullData,
          searches: action.payload.searches,
          sort: action.payload.sort,
        });
        return {
          ...state,
          fullData,
          filteredData,
          totalSeats: action.payload.partyData.yrdata[0].ttl_seats,
          infoMsg: action.payload?.yearData?.exitPollObject?.infoMsg,
          infoMsgCommon:
            action.payload?.yearData?.exitPollObject?.infoMsgCommon,
          refreshinterval:
            action.payload?.yearData?.exitPollObject?.refreshinterval,
          activeSeats:
            action.payload.partyData.yrdata[0].ttl_seats -
            (action.payload.yearData.exitPollObject.states &&
            Array.isArray(action.payload.yearData.exitPollObject.states) &&
            action.payload.yearData.exitPollObject.states.length > 0
              ? action.payload.yearData.exitPollObject.states.reduce(
                  (accumulator, s) =>
                    accumulator +
                    parseInt(
                      isNaN(s?.disableSeatCount) ? 0 : s?.disableSeatCount,
                      10,
                    ),
                  0,
                )
              : 0),
          winSeats: fullData.reduce((acc, party) => acc + party.ws, 0),
          leadWinSeats: fullData.reduce(
            (acc, party) => acc + party.ws + party.ls,
            0,
          ),
        };
      }
      return { ...state };
    }
    case RECEIVE_YEAR_WISE_CANDIDATE_DATA: {
      let data = action.payload.candidateData;
      let stateConstMapping;
      if (
        !action.payload.yearData.loksabha &&
        data &&
        Object.values(data) &&
        Array.isArray(Object.values(data)) &&
        Object.values(data).length
      ) {
        stateConstMapping = Object.values(data)[0]?.cns_rslt.reduce(
          (accumulator, currentValue) => {
            const { cns_name } = currentValue;
            if (!accumulator[cns_name]) {
              accumulator[cns_name] = {
                name: currentValue.cns_name,
                seoname: createSlug(currentValue.cns_name),
              };
            }
            return accumulator;
          },
          {},
        );
        stateConstMapping = {
          [Object.keys(data)[0]]: Object.values(stateConstMapping),
        };
        data = Object.values(data)[0]?.cnt_rslt.map(cnt => ({
          ...cnt,
          seonm: createSlug(cnt.sn),
        }));
      }

      if (
        action?.payload?.yearData?.loksabha &&
        action?.payload?.force &&
        action?.payload?.searches?.sn
      ) {
        data = getSortedAndSearchData({
          data,
          searches: { sn: action.payload.searches.sn },
          sort: action.payload.sort,
        });
      }

      const starCandidatesData = action?.payload?.yearData?.loksabha
        ? data.filter(candidate => {
            if (typeof candidate?.star === 'string') {
              const channels = candidate.star.toLowerCase().split(',');
              const condition =
                action?.payload?.force && action?.payload?.searches?.sn
                  ? channels.includes('tois')
                  : channels.includes('toi');
              return condition;
            }
            return false;
          })
        : data.filter(
            candidate =>
              candidate.star === true &&
              candidate.starMeta &&
              candidate.starMeta.TOI === '1',
          );

      if (action?.payload?.starCandidatePage) {
        data = starCandidatesData;
      }

      let stateToReturn = {
        ...state,
        fullData: data,
        filteredData: getSortedAndSearchData({
          data,
          searches: action.payload.searches,
          sort: action.payload.sort,
        }),
        starCandidatesData,
        loksabha: !!action.payload.yearData.loksabha,
        force: action.payload?.force,
      };

      if (!action.payload.yearData.loksabha) {
        stateToReturn = { stateConstMapping, ...stateToReturn };
      }
      return stateToReturn;
    }
    case RECEIVE_YEAR_WISE_SCHEDULE_DATA: {
      const fullData = constituencyPhaseData(action.payload.scheduleData);
      return {
        ...state,
        fullData,
        filteredData: getSortedAndSearchData({
          data: fullData,
          searches: action.payload.searches,
          sort: action.payload.sort,
          schedule: true,
        }),
      };
    }
    case RECEIVE_FILTER_DATA: {
      return {
        ...state,
        filteredData: getSortedAndSearchData({
          data: state.fullData,
          searches: action.payload.searches,
          sort: action.payload.sort,
          schedule: action.payload.schedule,
        }),
      };
    }
    case RECEIVE_LATEST_YEAR_TOP_CANDIDATE_DATA: {
      let payload;
      let loksabha;
      if (
        action.payload &&
        Array.isArray(action.payload) &&
        action.payload.length
      ) {
        const filteredData = action.payload.filter(
          data =>
            data.tn === 'consistuency_results' ||
            data.tn === 'loksabha_candidate_show',
        );
        if (
          Array.isArray(filteredData) &&
          filteredData.length &&
          filteredData[0].items &&
          Array.isArray(filteredData[0].items) &&
          filteredData[0].items.length
        ) {
          payload = filteredData[0].items[0];
          loksabha = filteredData[0].loksabha;
        }
      }
      return {
        ...state,
        loksabha,
        latestYearData: payload,
      };
    }
    case RECEIVE_LATEST_YEAR_TOP_CANDIDATE_DATA_REFRESH: {
      let payload;
      if (
        !state.loksabha &&
        action.payload &&
        Object.values(action.payload) &&
        Object.values(action.payload).length &&
        Object.values(action.payload)[0]
      ) {
        payload = Object.values(action.payload)[0]?.cnt_rslt;
      } else if (
        state.loksabha &&
        action.payload.yrdata &&
        Array.isArray(action.payload.yrdata) &&
        action.payload.yrdata.length &&
        action.payload.yrdata[0]?.states &&
        Array.isArray(action.payload.yrdata[0]?.states) &&
        action.payload.yrdata[0]?.states.length &&
        action.payload.yrdata[0]?.states[0] &&
        action.payload.yrdata[0]?.states[0]?.cns &&
        Array.isArray(action.payload.yrdata[0]?.states[0]?.cns) &&
        action.payload.yrdata[0]?.states[0].cns.length &&
        action.payload.yrdata[0]?.states[0].cns[0]?.cnt
      ) {
        payload = action.payload.yrdata[0]?.states[0].cns[0]?.cnt;
      }
      return {
        ...state,
        latestYearData: getVsCandidatesInConstituency(
          payload,
          action.payload.constituency,
        ),
      };
    }
    case RECEIVE_WU_DATA: {
      const index = state.data.sectionitems.findIndex(
        section => section.id === action.payload.key,
      );
      if (index > -1 && action?.payload?.data?.items) {
        state.data.sectionitems[index].items = action?.payload?.data?.items;
      } else if (index > -1 && !action?.payload?.data?.items) {
        state.data.sectionitems[index].data = action?.payload?.data;
      }
      return {
        ...state,
      };
    }
    case RECEIVE_PHOTO_LISTING_PAGE_DATA: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case RECEIVE_CARDS_INSERT_DATA: {
      return {
        ...state,
        cardsInserts: action.payload,
      };
    }
    case HANDLE_CARDS_INSERTS_DATA_ERROR: {
      return {
        ...state,
        cardsInserts: {},
      };
    }
    case RECEIVE_AJAX_SECTION_DATA: {
      const { ajaxData = {} } = action.payload;
      const { params = {} } = action.payload;
      let indexOfFetchedSectionInSectionArray;
      const nextState = produce(state, draftState => {
        const pageData = _get(draftState, 'data');

        if (_get(pageData, 'sectionitems') instanceof Array) {
          pageData.sectionitems.forEach((item, index) => {
            if (params.sectionId === item.id) {
              indexOfFetchedSectionInSectionArray = index;
            }
          });

          if (typeof indexOfFetchedSectionInSectionArray === 'number') {
            pageData.sectionitems[indexOfFetchedSectionInSectionArray].items =
              ajaxData.items;
            pageData.sectionitems[indexOfFetchedSectionInSectionArray].path =
              (params.clickedItem && params.clickedItem.path) ||
              pageData.sectionitems[indexOfFetchedSectionInSectionArray].path;
          }
        } else {
          // console.log('section not found');
        }
      });

      return nextState;
    }
    case RECEIVE_HALLOFFAME_DETAILS_PAGE_DATA: {
      return {
        ...state,
        hallOfFame: action.payload,
      };
    }
    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
